import React, { useState, useEffect } from "react";
import { Button, Table, Row, Col, Card, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import Page from "components/common/Page";
import GetBack from "components/refactoring/BackButton";
import { Trans} from "react-i18next";
import { ApiClient } from "services";
import LoadingMsg from "components/common/LoadingMsg";

export const getOutlineStyle = (color, size) => ({
    border: `2px solid ${color}`,
    color: color,
    padding: '0.25rem 0.5rem',
    borderRadius: '0.2rem',
    fontSize: size
  });


export const InvoiceView = ({
    t,
    match,
    i18n,
}) => {

    const client = ApiClient() 

    const [invData, setinvoiceData] = useState();
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        try {
          setLoading(true)
          const responseOrg = await client.get(`core/invoice/${match.params.id}/view_invoice`);
          const invdata = responseOrg.data;
          setinvoiceData(invdata);
          setLoading(false)
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false)
        }
      };

    useEffect(() => {
    
      fetchData();
    }, []);

    const company = invData?.company_detail
    const organisation = invData?.organisation_detail
    const invoice = invData?.subscription_invoice
    const billingaddress = invData?.subscription_invoice?.subscription_billing_address
    const invoiceline = invData?.subscription_invoice?.subscription_line_item

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = async (id, invoice_number, language)  => {

        setDownloading(true)
        try {
          const response = await client.get(`/core/invoice/${id}/download_invoice?lang=${language}`, { responseType: 'blob' });
      
          const blob = new Blob([response.data], { type: response.data.type });
      
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          console.log("Blob==", blob)
          link.download = `${invoice_number}.pdf`;
          link.click();
      
          window.URL.revokeObjectURL(link.href);
          setDownloading(false)
        } catch (error) {
            setDownloading(false)
            console.error("Error fetching data:", error);
        }
      };

      const status_map = {
        'Paid':{'color':'#72B566', text:t('Paid')},
        'Unpaid':{'color':'#ffc107', text:t('Unpaid')},
        'Cancelled':{'color':'#dc3545', text:t('Cancelled')}
      }
    
      const [dropdownOpen, setDropdownOpen] = useState(false);
      const [downloading, setDownloading] = useState(false);
      const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
    
      const languageOptions = [
        { code: 'en', name: 'English' },
        { code: 'ar', name: 'Arabic' },
        { code: 'de', name: 'German' },
        { code: 'id', name: 'Indonesian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'es', name: 'Spanish' },
        { code: 'fr', name: 'French' },
        { code: 'it', name: 'Italian' },
        { code: 'ko', name: 'Korean' },
        { code: 'tr', name: 'Turkish' },
      ];

    return (
        
  <Page>
    <GetBack styleClass="my-2"></GetBack>
    <Row className="mb-2">
        <Col lg>
        
        {invoice?.status === "Paid" &&
        <>
        {!downloading?  
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle caret color="success" className="float-right">
                <i className="fa fa-file-pdf mr-2" /><Trans>Download PDF</Trans>
            </DropdownToggle> 
            <DropdownMenu>
                {languageOptions.map((language) => (
                  <DropdownItem
                    key={language.code}
                    onClick={() =>
                      handleDownload(
                        invData?.id,
                        invoice?.invoice_number || invoice?.local_invoice_number,
                        language.code
                      )
                    }
                  >
                    <Trans>{language.name}</Trans>
                  </DropdownItem>
                ))}
                
            </DropdownMenu>
            </Dropdown>
            : 
            <Button disabled color="primary float-right ml-2"><i className="fa fa-spinner fa-spin"/> <Trans>Downloading</Trans></Button>}
            </>
        }
        {/* <Button className="btn btn-primary float-right"  onClick={handlePrint}>Print</Button> */}
        {invoice?.status && <span className="float-right" style={getOutlineStyle(status_map[invoice.status].color)}>{status_map[invoice.status].text}</span>}
        </Col> 
    </Row>
    <Row className="mb-2">
      <Col lg>
        <Card className="my-3 p-2" style={{ border: '10px solid #DDDDDD' }}>
            <CardBody>
                {/*
                <Row>
                    <Col className="text-right">
                        <img
                        src="/images/logo.svg"
                        alt="Logo"
                        style={{ maxHeight: "auto", width: "100px" }}
                        />
                    </Col>
                </Row> 
                */}
                <Row>
                    <Col>
                        <p>{company?.name}</p>
                        <p>{organisation?.name}</p>
                        <p><Trans>VAT Registration no.</Trans> {company?.tax_number}</p>
                        <p><Trans>Contact:</Trans> {company?.contact_number}</p>
                        <p><Trans>Email:</Trans> {company?.email}</p>
                        <p>{company?.country}.</p>
                    </Col>
                    <Col>
                        <h1>Tax Invoice</h1>
                    </Col>
                    <Col>
                        <img
                        src={`data:image/png;base64, ${invData?.generate_qrcode}`}
                        alt="QR"
                        style={{ width: "200px" }}
                        className="border"
                        />
                    </Col>
                    
                    <Col>
                        <h6><Trans>Invoice Date</Trans></h6>
                        <p>{invoice?.issue_date}</p>
                        <h6><Trans>Invoice Number</Trans></h6>
                        <p>{invoice?.invoice_number}</p>
                        <h6><Trans>Supply Date</Trans></h6>
                        <p>{invoice?.due_date}</p>
                    </Col>
                    <Col>
                        <p>Hesaab Riyada Company</p>
                        <p>VAT Registration no. 310-1575181-00003</p>
                        <p>P.O.Box 261964 Riyadh 11342, KSA</p>
                        <p>Riyadh Office: 966-11-2911261</p>
                    </Col>
                </Row>
                
                <Row>
                    <Col>
                        <Table size="" className="">
                            <thead>
                                <tr>
                                    <th className="text-left"><Trans>Description</Trans></th>
                                    <th className="text-center"><Trans>Quantity</Trans></th>
                                    <th className="text-center"><Trans>Unit Price</Trans></th>
                                    <th className="text-center"><Trans>Discount %</Trans></th>
                                    <th className="text-center"><Trans>Tax Rate</Trans></th>
                                    <th className="text-right"><Trans>Tax Amount</Trans></th>
                                    <th className="text-right"><Trans>Amount (SAR)</Trans></th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoiceline?.map((i) => (
                                <tr key={i.id}>
                                    <td className="text-left">{i.item_name}</td>
                                    <td className="text-center">{i.quantity}</td>
                                    <td className="text-center">{i.unit_price}</td>
                                    <td className="text-center">0.00 %</td>
                                    <td className="text-center">{i.vat_percent}</td>
                                    <td className="text-center">{i.vat_amount}</td>
                                    <td className="text-right">{i.unit_price}</td>
                                </tr>
                                ))}
                                <tr>
                                    <td colSpan="4">
                                        
                                    </td>
                                    <td colSpan="4">
                                        <Table>
                                            <tr>
                                                <td className="text-center"><Trans>Sub Total</Trans></td>
                                                <td></td>
                                                <td className="text-right">{invoice?.sub_total}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center"><Trans>Total Discount</Trans></td>
                                                <td></td>
                                                <td className="text-right">{invoice?.discounted_amont}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center"><Trans>Total Tax</Trans></td>
                                                <td></td>
                                                <td className="text-right">{invoice?.vat_amount}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center"><Trans>Total SAR</Trans></td>
                                                <td></td>
                                                <td className="text-right">{invoice?.total_amount}</td>
                                            </tr>
                                            {invoice?.status === 'Paid' && 
                                            <>
                                            <tr>
                                                <td className="text-center"><Trans>Less Amount Paid</Trans></td>
                                                <td></td>
                                                <td className="text-right">{invoice?.total_amount}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center"><Trans>Amount Due</Trans></td>
                                                <td></td>
                                                <td className="text-right">0.00</td>
                                            </tr>
                                            </>}

                                        </Table>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table>
                            
                        </Table>
                    </Col>
                </Row>
            </CardBody>
        </Card>
      </Col>
    </Row>
  </Page>
)};

export default InvoiceView;
